const PHONE_RE = /(?:\(\d{3}\)\s*\d{3}-\d{4}|\b\d{3}-\d{3}-\d{4}\b)/g;

function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function linkPhoneTel(text) {
  const source = String(text ?? '');
  return source.replace(PHONE_RE, (match, offset) => {
    const labelStart = source.lastIndexOf('[', offset);
    const labelEnd = source.indexOf('](tel:', offset);
    if (labelStart !== -1 && labelEnd !== -1 && labelStart < offset) {
      return match;
    }
    const digits = match.replace(/\D/g, '');
    if (digits.length !== 10) return match;
    return `[${match}](tel:+1${digits})`;
  });
}

const MD_LINK_RE =
  /\[([^\]]+)\]\(((?:https?:\/\/|mailto:|tel:)[^)\s]+)\)/gi;

function markdownLinkHtml(label, href) {
  const isHttp = /^https?:\/\//i.test(href);
  const isTel = /^tel:/i.test(href);
  const attrs = [
    `href="${href}"`,
    isTel ? 'class="review-phone-chip"' : 'class="review-comment-link"',
  ];
  if (isHttp) attrs.push('target="_blank"', 'rel="noopener noreferrer"');
  return `<a ${attrs.join(' ')}>${label}</a>`;
}

function linkPhonesInPlainText(text) {
  return text.replace(PHONE_RE, (match) => {
    const digits = match.replace(/\D/g, '');
    if (digits.length !== 10) return match;
    return `<a href="tel:+1${digits}" class="review-phone-chip">${match}</a>`;
  });
}

function linkPhoneTelHtml(text) {
  const withLinks = escapeHtml(text).replace(MD_LINK_RE, (match, label, href) =>
    markdownLinkHtml(label, href),
  );
  return withLinks
    .split(/(<[^>]+>)/g)
    .map((part) => (part.startsWith('<') ? part : linkPhonesInPlainText(part)))
    .join('');
}

module.exports = {
  linkPhoneTel,
  linkPhoneTelHtml,
};
